
<template>
  <div>
    <div class="form-row div-valign">
      <div class="form-group col-md-6">
        <label>
          เลขที่สัญญา
          <span class="required">*</span>
          <!-- <span class="text-white">N-SCG_3</span> -->
        </label>
        <input
          v-model="ctrNo"
          name="ctrNo"
          data-vv-as="เลขที่สัญญา"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"

          :class="{'input': true, 'is-danger': errors.has('ctrNo') }"
          type="text"
          class="form-control"
        >

        <span v-show="errors.has('ctrNo')" class="help is-danger">{{ errors.first('ctrNo') }}</span>
      </div>
      <div class="form-group col-md-6">
        <label>วันที่ลงสัญญา
          <span class="required">*</span>
          <!-- <span class="text-white">N-SCG_3</span> -->
        </label>

        <date-picker
          v-model="ctrDate"
          name="ctrDate"
          ref="ctrDate"
          format="DD/MM/YYYY"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1 && this.appVo.modifyFlag!=='Y'"
          data-vv-as="วันที่ลงสัญญา"
          lang="th"
          :class="{'input': true, 'is-danger': errors.has('ctrDate') }"
          placeholder
        ></date-picker>

        <!-- <DslDate 
          v-model="ctrDate"
          name="ctrDate"
          ref="ctrDate"
          dateFormat="DD/MM/YYYY"
          v-validate="{ required:true}"
          :disabled="this.reqType !== 1"
          placeholder
          data-vv-as="วันที่ลงสัญญา"
          :class="{'input': true, 'is-danger': errors.has('ctrDate') }"
        ></DslDate> -->
        <span v-show="errors.has('ctrDate')" class="help is-danger">{{ errors.first('ctrDate') }}</span>  
        
      </div>
    </div>
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";

export default {
  inject: ["$validator"],
  props: ["reqType","appVo"],
  components: {
    DatePicker
  },
  data() {
    return {
      ctrNo: "",
      ctrDate: ""
      // reqType:this.reqType,
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){
      this.ctrNo = this.appVo.ctrNo;
      this.ctrDate = moment(this.appVo.ctrDate, 'DD/MM/YYYY');
    }
  },    
  watch: {
    ctrNo(newDate, oldDate) {
      this.$emit("childToParent", {
        ctrNo: this.ctrNo,
        ctrDate: this.ctrDate
      });
    },
    ctrDate(newDate, oldDate) {
      this.$emit("childToParent", {
        ctrNo: this.ctrNo,
        ctrDate: this.ctrDate
      });
    }
  }
};
</script>
                          
